import { useLanguage } from '@/i18n';
import { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'lv', label: 'LV', name: 'Latviešu' },
  { code: 'lt', label: 'LT', name: 'Lietuvių' }
];

const LanguageSwitcher = ({ light = false }) => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const currentLang = languages.find(l => l.code === language) || languages[0];
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          light 
            ? 'bg-white/20 text-white hover:bg-white/30' 
            : 'bg-[#F1F5F9] text-[#0F172A] hover:bg-[#E2E8F0]'
        }`}
        data-testid="language-switcher"
      >
        {currentLang.label}
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className={`absolute right-0 mt-2 py-1 w-32 rounded-md shadow-lg z-50 ${
          light ? 'bg-white/95 backdrop-blur-sm' : 'bg-white'
        } border border-[#E2E8F0]`}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                setIsOpen(false);
              }}
              className={`w-full px-3 py-2 text-left text-sm flex items-center justify-between hover:bg-[#F1F5F9] transition-colors ${
                language === lang.code ? 'text-[#8B1B3A] font-medium' : 'text-[#475569]'
              }`}
            >
              <span>{lang.name}</span>
              <span className="text-xs text-[#94A3B8]">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
